import { useEffect, useRef } from 'react';

import { selectIsOpen, useStore } from '~/store';

export const GoogleAnalytics = () => {
  const isOpen = useStore(selectIsOpen);
  const hasLoaded = useRef(false);

  useEffect(() => {
    if (!isOpen || hasLoaded.current) return;

    hasLoaded.current = true;

    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-D168YDY20V';
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      const gtag = (...args: unknown[]) => {
        window.dataLayer.push(args);
      };
      window.gtag = gtag;

      gtag('js', new Date());
      gtag('config', 'G-D168YDY20V');
      gtag('event', 'page_view', {
        page_location: window.location.href,
      });
    };

    return () => {
      document.head.removeChild(script);
    };
  }, [isOpen]);

  return null;
};
